<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" @click="open" data-testid="client-banner-membership">
            <template v-if="client.membership">
                <span class="badge badge-primary badge_membership" data-testid="client-membership-expiring" v-if="membershipExpiresSoon(client.membership) && (client.membership.has_next_membership === false)" v-tooltip="{
                    content: 'končí již: <b>' + client.membership.valid_to + '</b>' + (client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
                        placement: 'bottom-center',
                        classes: ['danger']}">
                    <i class="fa fa-warning text-danger" aria-hidden="true"></i>
                    <i class="fa fa-dollar text-danger" data-testid="client-membership-unpaid" v-if="client.membership.paid === false"></i>
                    {{ client.membership.name }}
                </span>
                <span class="badge badge-primary badge_membership" data-testid="client-membership-active" v-else="" v-tooltip="{
                        content: 'platný do: <b>' + client.membership.valid_to + '</b>' + (client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
                        placement: 'bottom-center',
                        classes: ['info']}">
                    <i class="fa fa-dollar text-danger" data-testid="client-membership-unpaid" v-if="client.membership.paid === false"></i>
                    {{ client.membership.name }}
                </span>
            </template>
            <span class="badge badge-secondary badge_membership" data-testid="client-membership-last" v-else-if="client.last_membership" v-tooltip="{
                content: 'skončil: <b>' + client.last_membership.valid_to,
                placement: 'bottom-center',
                classes: ['secondary']}"><i class="fa fa-warning" aria-hidden="true"></i> poslední: {{ client.last_membership.name }}</span>
            <span class="badge badge-warning badge_membership" data-testid="client-membership-none" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span>

            <!-- <span class="badge badge-primary badge_membership" v-if="client.membership">{{ client.membership.name }}</span>
            <span class="badge badge-secondary badge_membership" v-else-if="client.last_membership"><i class="fa fa-warning" aria-hidden="true"></i> poslední: {{ client.last_membership.name }}</span>
            <span class="badge badge-warning badge_membership" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span> -->
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col" v-if="!programsPending">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left">
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-membership-change" @click="edit" v-if="editMode === false && client.membership"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> změnit</button>
                        <button class="btn btn-sm btn-outline-secondary" data-testid="client-membership-back" @click="view" v-else-if="editMode === true"><i class="fa fa-arrow-left" aria-hidden="true"></i> zpět</button>
                    </div>
                    <div class="col-sm-8" v-if="editMode === true">Úprava programu</div>
                    <div class="col-sm-8" v-else-if="!client.membership">Výběr programu</div>
                    <div class="col-sm-8" v-else="">Detail programu</div>
                    <div class="col-sm-2"></div>
                </div>

                <div>
                    <div class="row">
                        <table class="table">
                            <thead>
                            <tr class="row m-0">
                                <th class="col-sm-3">program</th>
                                <th class="col-sm-3 text-right">platný od</th>
                                <th class="col-sm-2 text-right">platný do</th>
                                <th class="col-sm-2 text-right">zaplaceno</th>
                                <th class="col-sm-2 text-right"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="cm in clientMemberships">
                                <template>
                                    <tr class="row m-0 text-left" data-testid="client-membership-row" :class="cm.is_valid ? 'font-weight-bold' : ''">
                                        <td class="col-sm-3" :class="cm.program.is_valid ? 'font-weight-bold' : ''">{{ cm.program.name }}</td>
                                        <td class="col-sm-3 text-right">{{ cm.valid_from }}</td>
                                        <td class="col-sm-2 text-right">{{ cm.valid_to }}</td>
                                        <td class="col-sm-2 text-right">{{ cm.paid | boolAndNullToCS('&nbsp;')}}
                                          <template v-if="cm.fakturoid_invoice_id">
                                            <a target="_blank" :href="setting.hostname + 'membership/' + cm.id + '/invoice/pdf'" class="btn btn-sm btn-success text-white">FA</a>
                                          </template>
                                        </td>
                                        <td class="col-sm-2 text-right">
                                            <button v-if="!updateMembershipPending && cm.id !== membershipToUpdateId" data-testid="client-membership-edit" @click="updateMembership(cm)" class="btn btn-sm btn-link"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                            <button v-else-if="cm.id === membershipToUpdateId" @click="membershipToUpdateId = null" class="btn btn-sm btn-link"><i class="fa fa-times" aria-hidden="true"></i></button>
                                            <button class="btn btn-sm btn-outline-secondary disabled" v-else disabled="disabled"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                            <button v-if="!deleteMembershipPending" data-testid="client-membership-delete" @click="deleteMembership(cm.id)" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                                            <button class="btn btn-sm btn-outline-danger disabled" v-else disabled="disabled"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                                        </td>
                                    </tr>
                                    <tr class="row m-0 no-top-border-td no-padding-top-td" v-if="cm.note">
                                        <td class="col-sm-1"></td>
                                        <td class="col-sm-11 font-italic text-left">
                                            {{ cm.note }}
                                        </td>
                                    </tr>
                                    <tr class="row m-0 no-top-border-td no-padding-top-td" v-if="cm.id === membershipToUpdateId">
                                        <td class="col-sm-10">
                                            <form @submit.prevent="putMembership(cm.id)">
                                                <div class="row">
                                                    <div class="col-sm-6 form-group">
                                                        <label for="programSelect">Program</label>
                                                        <select @change="recalculateDateProgramChanged($event)" class="form-control" data-testid="client-membership-update-program" v-model="membershipToUpdate.program.id" id="programSelect">
                                                            <option v-for="p in programs" v-bind:value="p.id" :data-days="p.default_days">{{ p.name }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 form-inline">
                                                        <label for="paid" class="mr-sm-2">
                                                            zaplaceno <input v-model="membershipToUpdate.paid" class="form-check-input" type="checkbox" data-testid="client-membership-update-paid" id="paid">
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-6 form-inline">
                                                        <label for="validFrom">platnost od: </label>
                                                        <datepicker v-model="membershipToUpdate.valid_from" v-on:input="recalculateDateValidFromChanged()" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validFrom" id="validFrom"></datepicker>
                                                    </div>
                                                    <div class="col-sm-6 form-inline">
                                                        <label for="validTo">platnost do: </label>
                                                        <datepicker v-model="membershipToUpdate.valid_to" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validTo" id="validTo"></datepicker>
                                                    </div>
                                                    <div class="col-sm-12 form-group">
                                                        <label for="note">poznámka: </label>
                                                        <input v-model="membershipToUpdate.note" type="text" class="form-control" data-testid="client-membership-update-note" aria-describedby="noteHelp" id="note">
                                                    </div>
                                                    <div class="col-sm-12 form-group text-center">
                                                        <button v-if="!updateMembershipPending" data-testid="client-membership-update-save" type="submit" class="btn btn-success btn-sm">Uložit</button>
                                                        <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </td>

                                    </tr>
                                </template>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="!client.membership || (editMode === true && membershipToUpdateId === null)">
                    <form @submit.prevent="postMembership(client.id)">
                        <div class="row bg-light">
                            <div class="col-sm-12 text-center">
                                <h5>Přidání nového programu</h5>
                            </div>
                            <div class="col-sm-6 form-group">
                                <label for="programSelect">Program</label>
                                <select @change="recalculateDateProgramChanged($event)" class="form-control" data-testid="client-membership-program" v-model="membership.program.id" id="programSelect">
                                    <option v-for="p in programs" v-bind:value="p.id" :data-days="p.default_days">{{ p.name }}</option>
                                </select>
                            </div>
                            <div class="col-sm-6 form-inline">
                              <template v-if="setting.fakturoid === true">
                                <label for="paid_by_card" class="mr-sm-2">
                                  platí kartou <input v-model="membership.paid_by_card" class="form-check-input" type="checkbox" data-testid="client-membership-paid-by-card" id="paid_by_card"> (jinak hotově)
                                </label>
                              </template>
                              <template v-else>
                                <label for="paid" class="mr-sm-2">
                                  zaplaceno <input v-model="membership.paid" class="form-check-input" type="checkbox" data-testid="client-membership-paid" id="paid">
                                </label>
                              </template>
                            </div>
                            <div class="col-sm-6 form-inline">
                                <label for="validFrom">platnost od: </label>
                                <datepicker v-model="membership.valid_from" v-on:input="recalculateDateValidFromChanged()" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validFrom" id="validFrom"></datepicker>
                            </div>
                            <div class="col-sm-6 form-inline">
                                <label for="validTo">platnost do: </label>
                                <datepicker v-model="membership.valid_to" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validTo" id="validTo"></datepicker>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="note">poznámka: </label>
                                <input v-model="membership.note" type="text" class="form-control" data-testid="client-membership-note" aria-describedby="noteHelp" id="note">
                            </div>
                            <div class="col-sm-12 form-group text-center">
                                <button v-if="!membershipPending" data-testid="client-membership-save" type="submit" class="btn btn-success btn-sm">Uložit</button>
                                <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        setting: require('@/variables.js'),
        programsPending: true,
        programsError: false,
        programs: null,
        editMode: false,
        membershipDone: false,
        membershipPending: false,
        membershipError: false,
        isOpen: false,
        membership: {
          valid_from: new Date(),
          valid_to: null,
          program: {
            id: null
          },
          note: '',
          paid: false,
          paid_by_card: false
        },
        birthDateCalculated: false,
        possibleDates: [],
        clientMembershipsPending: false,
        clientMemberships: null,
        clientMembershipsError: false,
        selected_default_days: null,
        // DELETE
        deleteMembershipPending: false,
        deleteMembershipDone: false,
        deleteMembershipError: false,
        // UPDATE
        updateMembershipPending: false,
        updateMembershipDone: false,
        updateMembershipError: false,
        membershipToUpdate: null,
        membershipToUpdateId: null
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      init () {
        this.membership = {
          valid_from: new Date(),
          valid_to: null,
          program: {
            id: null
          },
          note: '',
          paid: this.setting.fakturoid === true,
          paid_by_card: false
        }
      },
      open () {
        this.init()
        this.isOpen = true
        this.editMode = false
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      },
      recalculateDateProgramChanged (event) {
        this.selected_default_days = event.target.options[event.target.selectedIndex].getAttribute('data-days')
        console.log(event.target.options[event.target.selectedIndex].getAttribute('data-days'))
        this.recalculateValidTo()
      },
      recalculateDateValidFromChanged () {
        if (this.selected_default_days !== null) {
          this.recalculateValidTo()
        }
        // console.log(this.membership.valid_from)
      },
      recalculateValidTo () {
        this.membership.valid_to = this.$moment(this.membership.valid_from).add(this.selected_default_days, 'days').toDate()
        console.log(this.membership.valid_to)
      },
      updateMembership (membership) {
        console.log(membership)
        this.membershipToUpdate = {
          valid_from: this.$moment(membership.valid_from, 'DD.MM.YYYY').toDate(),
          valid_to: this.$moment(membership.valid_to, 'DD.MM.YYYY').toDate(),
          program: {
            id: membership.program.id
          },
          note: membership.note,
          paid: membership.paid
        }
        this.membershipToUpdateId = membership.id
        this.editMode = true
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          let startDate = this.$moment().subtract(1, 'year').dayOfYear(1)
          this.possibleDates = []
          for (let i = 0; i < 6; i++) {
            this.possibleDates.push(startDate.add(6, 'months').format('L'))
          }
          this.getPrograms()
          // if (this.client.membership || this.client.last_membership) {
          this.getClientMemberships(this.client.id)
          // }
        } else {
          this.programsPending = true
        }
      },
      membershipDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.membershipDone = false
          this.close()
        }
      },
      updateMembershipDone (val) {
        if (val === true) {
          this.membershipToUpdateId = null
          this.editMode = false
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.updateMembershipDone = false
          this.close()
        }
      },
      deleteMembershipDone (val) {
        if (val === true) {
          console.log('smazal jsem zmrda')
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.deleteMembershipDone = false
          this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .no-top-border-td > td {
        border-top: none;
    }

    .no-padding-top-td > td {
        padding-top: 0;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientMembership.vue?5358df99